module.exports = __webpack_public_path__ + "img/emoji_happy.ad6ab030.png";